(() => {
  const connect = (root) => {
    if (root.dataset.fvReviewReady) return;
    root.dataset.fvReviewReady = 'true';
    let evidence;
    try { evidence = JSON.parse(root.querySelector('[data-fv-review-evidence]').textContent) || []; }
    catch { evidence = []; }
    const reviews = new Map(evidence.map((review) => [review.uuid, review]));
    const format = () => {
      root.querySelectorAll('.jm-review-item[review-uuid]').forEach((item) => {
        const review = reviews.get(item.getAttribute('review-uuid'));
        const name = item.querySelector('.jm-reviewer-info__name');
        const date = item.querySelector('.jm-reviewer-info__details > .jm-cluster:nth-child(2) > .jm-text');
        if (!date) return;
        const match = date.textContent.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (match) date.textContent = `${match[3]}-${match[1]}-${match[2]}`;
      });
    };
    format();
    new MutationObserver(format).observe(root.querySelector('.fv-pdp-reviews__widget'), { childList: true, subtree: true });
  };
  const scan = (root) => root.querySelectorAll('[data-fv-review-layout]').forEach(connect);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
